module.exports = __webpack_public_path__ + "static/media/white-cross.655e3e36.svg";